"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var core_1 = require("@material-ui/core");
var i18next_1 = __importDefault(require("i18next"));
var go_main_logo_svg_1 = __importDefault(require("@assets/go-logo-graphics/go-main-logo.svg"));
var go_main_logo_light_svg_1 = __importDefault(require("@assets/go-logo-graphics/go-main-logo-light.svg"));
var go_main_logo_mini_svg_1 = __importDefault(require("@assets/go-logo-graphics/go-main-logo-mini.svg"));
var go_main_logo_mini_light_svg_1 = __importDefault(require("@assets/go-logo-graphics/go-main-logo-mini-light.svg"));
var help_icon_svg_1 = __importDefault(require("@assets/shared/help-icon.svg"));
var logout_icon_svg_1 = __importDefault(require("@assets/components/app/base-layout/logout-icon.svg"));
var logout_white_icon_svg_1 = __importDefault(require("@assets/components/app/base-layout/logout-white-icon.svg"));
var directory_icon_svg_1 = __importDefault(require("@assets/components/app/base-layout/directory-icon.svg"));
var feedback_icon_svg_1 = __importDefault(require("@assets/components/app/base-layout/feedback-icon.svg"));
var github_icon_svg_1 = __importDefault(require("@assets/components/app/base-layout/github-icon.svg"));
var signin_icon_svg_1 = __importDefault(require("@assets/components/app/base-layout/signin-icon.svg"));
var api_icon_svg_1 = __importDefault(require("@assets/components/app/base-layout/api-icon.svg"));
var home_icon_svg_1 = __importDefault(require("@assets/components/app/base-layout/home-icon.svg"));
var Section_1 = __importDefault(require("../Section"));
var actions_1 = __importDefault(require("../../../login/actions"));
var useStyles = core_1.makeStyles(function (theme) {
    var _a, _b, _c;
    return core_1.createStyles({
        appBar: (_a = {
                zIndex: 1,
                boxShadow: 'none',
                flexShrink: 1,
                paddingTop: theme.spacing(2),
                paddingBottom: theme.spacing(2)
            },
            _a[theme.breakpoints.up('md')] = {
                paddingTop: function (props) {
                    return props.isLoggedIn ? theme.spacing(2) : theme.spacing(4);
                },
            },
            _a[theme.breakpoints.up('lg')] = {
                paddingTop: function (props) {
                    return props.isLoggedIn ? theme.spacing(2) : theme.spacing(6);
                },
            },
            _a),
        toolbar: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            paddingLeft: theme.spacing(0),
            paddingRight: theme.spacing(0),
        },
        rowSpace: {
            flexGrow: 0.85,
        },
        appBarSignOutBtn: {
            // fill: theme.palette.primary.main,
            color: function (props) {
                return props.isLightItems ? 'white' : theme.palette.text.primary;
            },
            order: 10,
        },
        appBarSignInBtn: {
            width: '140px',
            minWidth: '90px',
            order: 10,
            color: function (props) {
                return props.isLightItems ? theme.palette.text.primary : 'white';
            },
            background: function (props) {
                return props.isLightItems ? 'white' : theme.palette.primary.main;
            },
        },
        signInIcon: {
            paddingLeft: theme.spacing(0.5),
        },
        toolbarLogo: {
            maxWidth: '130px',
            width: '40%',
        },
        logo: (_b = {
                display: 'flex',
                width: '100%',
                height: '100%'
            },
            _b[theme.breakpoints.down('sm')] = {
                width: 'auto',
            },
            _b),
        headerButton: (_c = {
                filter: function (props) { return (props.isLightItems ? 'brightness(10)' : ''); }
            },
            // this class is not mobile first by default as padding should not be set
            // when it is not mobile.
            _c[theme.breakpoints.down('xs')] = {
                paddingLeft: 0,
                paddingRight: 0,
                minWidth: theme.spacing(6),
            },
            _c),
        logoutIcon: {
            width: '24px',
        },
        sectionPage: {
            paddingTop: function (props) { return (props.isSticky && props.toStick ? '76px' : '0px'); },
        },
    });
});
var BaseLayoutHeader = function (_a) {
    var backgroundType = _a.backgroundType, _b = _a.hideNavButtons, hideNavButtons = _b === void 0 ? false : _b, isSticky = _a.isSticky, toStick = _a.toStick;
    var isLoggedIn = react_redux_1.useSelector(function (state) { return state.login.isLoggedIn; });
    var dispatch = react_redux_1.useDispatch();
    var logout = function () { return dispatch(actions_1.default.logout()); };
    var isLightItems = backgroundType === 'darkest';
    var theme = core_1.useTheme();
    var isMobileVariant = core_1.useMediaQuery(theme.breakpoints.down('sm'));
    var classes = useStyles({ isLoggedIn: isLoggedIn, isLightItems: isLightItems, isSticky: isSticky, toStick: toStick });
    var headers = [
        {
            text: 'Dashboard',
            link: i18next_1.default.t('general.links.dashboard'),
            public: false,
            icon: home_icon_svg_1.default,
            mobileOrder: 1,
            internalLink: true,
        },
        {
            text: 'Directory',
            link: i18next_1.default.t('general.links.directory'),
            public: false,
            icon: directory_icon_svg_1.default,
            mobileOrder: 2,
            internalLink: true,
        },
        {
            text: 'API Integration',
            link: i18next_1.default.t('general.links.apiintegration'),
            public: false,
            icon: api_icon_svg_1.default,
            mobileOrder: 3,
            internalLink: true,
        },
        {
            text: 'Send us feedback',
            link: i18next_1.default.t('general.links.feedback'),
            public: true,
            icon: feedback_icon_svg_1.default,
        },
        {
            text: 'Guide',
            link: i18next_1.default.t('general.links.faq'),
            public: true,
            icon: help_icon_svg_1.default,
        },
        {
            text: 'Contribute',
            link: i18next_1.default.t('general.links.contribute'),
            public: true,
            icon: github_icon_svg_1.default,
        },
        {
            text: 'Guide',
            link: i18next_1.default.t('general.links.faq'),
            public: false,
            icon: help_icon_svg_1.default,
            mobileOrder: 4,
        },
        {
            text: 'Send us feedback',
            link: i18next_1.default.t('general.links.contact'),
            public: false,
            icon: feedback_icon_svg_1.default,
            mobileOrder: 5,
        },
    ].filter(function (item) { return !item.public; });
    var appBarBtn = isLoggedIn ? (react_1.default.createElement(core_1.Button, { onClick: logout, size: "large", color: isLightItems ? 'primary' : 'secondary', variant: "text", className: classes.appBarSignOutBtn },
        react_1.default.createElement(core_1.Hidden, { xsDown: true },
            react_1.default.createElement("strong", null, "Sign out\u00A0")),
        isLightItems ? (react_1.default.createElement("img", { className: classes.logoutIcon, src: logout_white_icon_svg_1.default, alt: "Sign out" })) : (react_1.default.createElement("img", { className: classes.logoutIcon, src: logout_icon_svg_1.default, alt: "Sign out" })))) : (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.Hidden, { smDown: true },
            react_1.default.createElement(core_1.Button, { href: "/#/login", size: "large", variant: "contained", color: isLightItems ? 'default' : 'primary', className: classes.appBarSignInBtn }, "Sign in")),
        react_1.default.createElement(core_1.Hidden, { mdUp: true },
            react_1.default.createElement(core_1.Button, { href: "/#/login", size: "large", className: classes.headerButton },
                "Sign in",
                react_1.default.createElement("img", { src: signin_icon_svg_1.default, alt: "Sign in icon", className: classes.signInIcon, "aria-hidden": true })))));
    var getGoLogo = function () {
        if (isLightItems && isMobileVariant) {
            return go_main_logo_mini_light_svg_1.default;
        }
        if (isLightItems) {
            return go_main_logo_light_svg_1.default;
        }
        if (!isLightItems && isMobileVariant) {
            return go_main_logo_mini_svg_1.default;
        }
        return go_main_logo_svg_1.default;
    };
    return (react_1.default.createElement(Section_1.default, { backgroundType: backgroundType, verticalMultiplier: 0, shadow: !isLoggedIn && isMobileVariant, className: classes.sectionPage },
        react_1.default.createElement(core_1.AppBar, { position: "static", color: "transparent", className: classes.appBar },
            react_1.default.createElement(core_1.Toolbar, { className: classes.toolbar },
                react_1.default.createElement("a", { href: "/#/", className: classes.toolbarLogo },
                    react_1.default.createElement("img", { src: getGoLogo(), className: classes.logo, alt: "GoGovSG Logo" })),
                react_1.default.createElement("span", { className: classes.rowSpace }),
                !hideNavButtons &&
                    headers.map(function (header) {
                        return (header.public ? !isLoggedIn : isLoggedIn) && (react_1.default.createElement(core_1.Button, { href: header.internalLink ? "/#" + header.link : header.link, target: header.internalLink ? '' : '_blank', color: "primary", size: "large", variant: "text", key: header.text, className: classes.headerButton, style: isMobileVariant && header.mobileOrder
                                ? { order: header.mobileOrder }
                                : {} },
                            isMobileVariant && header.icon && (react_1.default.createElement("img", { src: header.icon, alt: header.text })),
                            !isMobileVariant && header.text));
                    }),
                !hideNavButtons && appBarBtn))));
};
exports.default = BaseLayoutHeader;
